import api from "./api";

// In-app notifications for the back-office. Rows are scoped server-side to
// the logged-in system user (req.user()->id), so this is safe to poll for
// any authenticated system user — a non-Bursar user just gets an empty list
// until something creates a notification targeting their user id (currently
// only "fee_created_by_admin", aimed at Bursar accounts). No permission
// middleware gates these routes: auth:sanctum is enough.

// GET /api/notifications/unread-count -> { unread_count }
export const getUnreadNotificationCount = () =>
  api.get("/api/notifications/unread-count").then((r) => r.data?.unread_count ?? 0);

// GET /api/notifications?page=&per_page=&unread_only=
// -> { unread_count, rows: [{id,type,title,body,data,read_at,created_at}], pagination }
export const listNotifications = (params = {}) =>
  api.get("/api/notifications", { params }).then((r) => r.data);

// POST /api/notifications/{id}/read -> { message, unread_count, id, type, ... } (flat, not nested)
export const markNotificationRead = (id) =>
  api.post(`/api/notifications/${id}/read`).then((r) => r.data);

// POST /api/notifications/read-all -> { message, updated_count, unread_count: 0 }
export const markAllNotificationsRead = () =>
  api.post("/api/notifications/read-all").then((r) => r.data);
